import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center"
    }
});

export const useStyles = ({
    shapeConfigs,
    typography,
    radiuses,
    spaces,
    colors
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
    colors: NCoreUIKit.ActivePalette["colors"];
    shapeConfigs: NCoreUIKit.ShapeConfigs;
    typography: NCoreUIKit.Typography;
    radiuses: NCoreUIKit.Radiuses;
}) => {
    const styles = {
        container: {
            minHeight: typography.labelSmallSize.lineHeight + spaces.spacingXxs * 2,
            backgroundColor: colors.content.container.inverse,
            paddingHorizontal: spaces.spacingSm,
            ...getCornerStyle({
                radius: radiuses.xs,
                shapeConfigs
            })
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
